import moment from 'moment';

import { ccassConstants, uiConstants } from '../constants';
import { parseCSV } from '../helpers/csv.helper';
import { normalizeStockCodeInItem } from '../helpers/stockCode.helper';
import { ccassService, miscService } from '../services';
import { alertActions } from '.';
import { generalErrorHandler, resetAbortController } from './utils';

export default {
  fetchStatistics, // remove it, doesn't need to be global
  fetchDetailStatistics, // remove it, doesn't need to be global
};

function groupByStockCode(
  list: any[],
  stockCodeFieldName = 'stockCode'
): { [key: string]: any } {
  const result = {};
  for (const item of list) {
    result[item[stockCodeFieldName]] = item;
  }
  return result;
}

function fetchStatistics(date) {
  const dateStr = moment.utc(date).format('YYYYMMDD');
  return dispatch => {
    const ac = resetAbortController(ccassConstants.STATISTICS_REQUEST);
    dispatch(request());
    dispatch(alertActions.clear());

    // due to part of the data is in AWS, the rest in our DB
    // we have to combine data from two different sources
    // that's why this code is so ugly, we should be able to
    // make API call into 1 when all data is in AWS
    return ccassService.statistics2(ac.signal, dateStr).then(
      data2 => {
        ccassService.statistics1(ac.signal, data2.date).then(data1 => {
          // combine data1.statistics, data2.stat, data2.diff
          const stat1ByStockCode = groupByStockCode(data1.statistics); // from DB
          const diffByStockCode = groupByStockCode(
            parseCSV<any>(data2.diff).map(normalizeStockCodeInItem)
          ); // from AWS
          const statistics = parseCSV<any>(data2.stat)
            .map(normalizeStockCodeInItem)
            // insert the data from stat1ByStockCode and diffByStockCode
            // into here
            .filter(item => stat1ByStockCode[item.stockCode]) // new stock might not have statistics
            .map(item => ({
              ...stat1ByStockCode[item.stockCode],
              ...diffByStockCode[item.stockCode], // should not have missing data
              ...item,
            })); // from AWS

          dispatch(
            success(
              statistics,
              moment(data2.date, 'YYYYMMDD').format(uiConstants.DATE_FORMAT),
              data1.updatedAt
            )
          );
        });
      },
      generalErrorHandler(dispatch, error =>
        dispatch(failure(error.toString()))
      )
    );
  };

  function request() {
    return { type: ccassConstants.STATISTICS_REQUEST };
  }
  function success(statistics, when, updatedAt) {
    return {
      type: ccassConstants.STATISTICS_SUCCESS,
      statistics,
      when,
      updatedAt,
    };
  }
  function failure(error) {
    return { type: ccassConstants.STATISTICS_FAILURE, error };
  }
}

function fetchDetailStatistics(date) {
  const dateStr = moment.utc(date).format('YYYYMMDD');
  return dispatch => {
    const ac = resetAbortController(ccassConstants.DETAIL_STATISTICS_REQUEST);
    dispatch(request());
    dispatch(alertActions.clear());

    return Promise.all([
      miscService.listStocks(ac.signal),
      ccassService.detailStatistics(ac.signal, dateStr),
    ]).then(
      ([stocks, data]) => {
        const { participants, date, stat, diff } = data;
        const diffByHold = groupByStockCode(parseCSV<any>(diff), 'Hold');
        const statistics = parseCSV<any>(stat)
          .map((item: any) => {
            // before Apr 9, 2021, the column name was "StockCode"
            // after is "Hold."
            const hold = item['Hold'] || item['StockCode'];
            const [rawStockCode, participantIdentifier] = hold.split(':');
            const stockCode = rawStockCode.split('.')[1].padStart(5, '0');
            const isParticipantId = !!participants[participantIdentifier];

            return {
              ...diffByHold[hold],
              ...item,
              ...stocks[stockCode],
              stockCode,
              ['participantId']: isParticipantId ? participantIdentifier : '',
              ['participantName']: {
                en: isParticipantId
                  ? participants[participantIdentifier].En
                  : participantIdentifier,
                zh: isParticipantId
                  ? participants[participantIdentifier].Zh
                  : participantIdentifier,
              },
            };
          })
          // ensure stock code is found in our DB
          .filter(({ stockCode }) => stockCode);

        dispatch(
          success(
            statistics,
            moment(date, 'YYYYMMDD').format(uiConstants.DATE_FORMAT)
          )
        );
      },
      generalErrorHandler(dispatch, error =>
        dispatch(failure(error.toString()))
      )
    );
  };

  function request() {
    return { type: ccassConstants.DETAIL_STATISTICS_REQUEST };
  }
  function success(statistics, when) {
    return {
      type: ccassConstants.DETAIL_STATISTICS_SUCCESS,
      statistics,
      when,
    };
  }
  function failure(error) {
    return { type: ccassConstants.DETAIL_STATISTICS_FAILURE, error };
  }
}
